module.exports = __webpack_public_path__ + "img/66.97a90fbe.png";